var map = {
	"./author/reducers": [
		"152bbc7cdea0196e886e"
	],
	"./payment/reducers": [
		"bb0f90cc4f5959ab3bd6",
		38447,
		96388
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "0891bdc2f63962695336";
module.exports = webpackAsyncContext;